import { useEffect } from "react";
import type { DashboardData } from "../types";
import { satisfies, type Need } from "../lib/coverage";

/**
 * For a screen that learns what it needs only once something in it is opened (a payee, a loan, a
 * bill): asks for the ledger back to `need` and says whether `data` holds it yet. The caller shows
 * a loading state, not partial totals, until it does.
 */
export function useLedgerNeed(data: DashboardData, need: Need | null, ensure: (need: Need) => unknown): boolean {
  useEffect(() => {
    if (need) void ensure(need);
  // `ensure` is recreated each render; only a different need should ask again.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [need]);
  return !need || satisfies(data, need);
}
